import React, { useState } from 'react';
import { Info } from 'lucide-react';

export default function DurationTooltip() {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        className="text-gray-500 hover:text-gray-700 focus:outline-none"
        onClick={() => setIsVisible(!isVisible)}
        aria-label="Informações sobre duração da disponibilidade"
      >
        <Info className="w-4 h-4" />
      </button>
      
      {isVisible && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 md:relative md:inset-auto md:bg-transparent">
          <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full md:absolute md:w-80 md:-left-20 md:transform md:-translate-x-1/2 md:mt-2">
            <div className="space-y-3">
              <h4 className="font-semibold text-gray-900">Duração da Disponibilidade</h4>
              <p className="text-sm text-gray-600">
                Selecione por quanto tempo sua disponibilidade ficará publicada na plataforma.
              </p>
              <p className="text-sm text-gray-600">
                Após o período selecionado, a disponibilidade será automaticamente expirada.
              </p>
              <p className="text-sm text-gray-600">
                Você poderá republicar sua disponibilidade a qualquer momento através do histórico da sua conta.
              </p>
            </div>
            <button
              className="md:hidden mt-4 w-full px-4 py-2 bg-blue-600 text-white rounded-lg"
              onClick={() => setIsVisible(false)}
            >
              Fechar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}